import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL  

class IntrestedCandidatesApi {
  getAllIntrestedCandidates(config) {
    return axios.get(BASE_URL + "/informationForm/getInformation", config)
  }
}

export default new IntrestedCandidatesApi()
